export const constants={
    'API_BASE':"https://vansale.spiceasiastore.com/api",
    'ADMIN':'admin',
    'VAN':'van',
    'WHOLESALEUSER':'wholesaleuser',
    'ERROR':'error',
    'SUCCESS':'success',
    'PERPAGE':10,
    'ORDER_ACTION':
                {
                VIEW:'view',
                DOWNLOAD:'download'
                },
    'PAYMENT_MODE':
                {
                CASH:'cash',
                BANKTRANSFER:'banktransfer',
                CARD:'card',
                PAYPAL:'paypal'
                },
    'PAYMENT_STATUS':{
           PAID:'paid',
           PENDING:'pending'
                 },
    'COUPEN_TYPE':{
        'FIXED':'fixed',
        'PERCENTAGE':'percentage'
    },
    'COUPEN_STATUS':{
        'ACTIVE':1,
        'BLOCKED':0
    },

    'TAX_PERCENTAGE' :7,
    'BARCODE_SCAN_MODE':{
        'CAMERA':'camera',
        'SCANNER':'scanner'
    }
}
